import { Controller } from "@hotwired/stimulus";

// Generic trigger + panel popover menu (context / actions menu).
export default class extends Controller {
  static targets = ["trigger", "panel"];

  declare readonly triggerTarget: HTMLButtonElement;
  declare readonly panelTarget: HTMLElement;

  toggle() {
    this.panelTarget.hidden ? this.open() : this.close();
  }

  open() {
    this.panelTarget.hidden = false;
    this.triggerTarget.setAttribute("aria-expanded", "true");
  }

  close() {
    this.panelTarget.hidden = true;
    this.triggerTarget.setAttribute("aria-expanded", "false");
  }

  select() {
    this.close();
    this.triggerTarget.focus();
  }

  clickOutside(event: Event) {
    if (!this.element.contains(event.target as Node)) this.close();
  }

  keydown(event: KeyboardEvent) {
    if (event.key === "Escape") this.close();
  }
}
